/**
 * Created by zzy on 2019/8/6.
 */
import { Bar, AnnularPie, AppTreeSide, UniDatePicker } from 'components'
import { loadRegionTree } from 'utils/tree'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import {getRegionList} from '@/api/get-data.js'

// 各区域接入、完善及未完善数量统计
const barData = [
  ['各区域数量对比', '接入数', '已完善数', '未完善数']
]
//
const barColor = ['#4CA2EB', '#41CF87', '#FFA03A']

//
const pieData = [
  ['建档占比', '全部完善数', '未完善数', '部分完善数', '基本完善数'],
  ['全部完善数', 0],
  ['未完善数', 0],
  ['部分完善数', 0],
  ['基本完善数', 0]
]
const pieColor = ['#41CF87', '#FF6B6B', '#FFA03A', '#FFF06E']
const pieTitle = { text: '建档占比', left: '30%', top: '45%' }
const pieLegend = { orient: 'vertical', top: '16%', right: '4%', itemGap: 45 }

// 行业级联选择器选项
const industryCascaderOptions = [
  {
    value: 99999999,
    label: '全部',
    children: [
      {
        value: 99009999,
        label: '政府机关',
        children: [
          {
            value: 999999,
            label: '社会治安路面'
          },
          {
            value: 1999999,
            label: '社会治安社区'
          },
          {
            value: 2999999,
            label: '社会治安内部'
          },
          {
            value: 3999999,
            label: '社会治安其他'
          },
          {
            value: 4999999,
            label: '交通路面'
          },
          {
            value: 5999999,
            label: '交通卡口'
          },
          {
            value: 6999999,
            label: '交通内部'
          },
          {
            value: 7999999,
            label: '交通其他'
          },
          {
            value: 8999999,
            label: '城市管理'
          },
          {
            value: 9999999,
            label: '卫生环保'
          },
          {
            value: 10999999,
            label: '商检海关'
          },
          {
            value: 11999999,
            label: '教育'
          }
        ]
      },
      {
        value: 99019999,
        label: '企事业单位',
        children: [
          {
            value: 40999999,
            label: '农林牧渔'
          },
          {
            value: 41999999,
            label: '采矿'
          },
          {
            value: 42999999,
            label: '制造'
          },
          {
            value: 43999999,
            label: '冶金'
          },
          {
            value: 44999999,
            label: '电力'
          },
          {
            value: 45999999,
            label: '燃气'
          },
          {
            value: 46999999,
            label: '建筑'
          },
          {
            value: 47999999,
            label: '物流'
          },
          {
            value: 48999999,
            label: '邮政'
          },
          {
            value: 49999999,
            label: '信息'
          },
          {
            value: 50999999,
            label: '住宿餐饮'
          },
          {
            value: 51999999,
            label: '金融'
          },
          {
            value: 52999999,
            label: '房地产'
          },
          {
            value: 53999999,
            label: '商业服务'
          },
          {
            value: 54999999,
            label: '水利'
          },
          {
            value: 55999999,
            label: '娱乐'
          }
        ]
      },
      {
        value: 99029999,
        label: '居民自建',
        children: [
          {
            value: 80999999,
            label: '居民自建'
          }
        ]
      },
      {
        value: 99039999,
        label: '其他',
        children: [
          {
            value: 90999999,
            label: '其他'
          }
        ]
      }
    ]
  }
]

export default {
  name: 'cameraArchiveStatistics',
  data () {
    return {
      // 活动页面索引
      activeTabName: '0',
      // 侧边栏打开标志
      treeSideBarOpen: true,
      // 树数据
      treeData: [],
      treeExpandedKeys: [], // 默认展开树节点key
      // 默认树属性
      defaultTreeProps: {
        label: 'name' // name字段作为label
      },
      // 树节点显示过滤
      treeNodeFilter: '',
      filteredTreeData: [],
      // 树查询条件
      treeQueryParams: {
        pageNum: 1,
        pageSize: 1000
      },
      // 表格数据
      tableData: [],
      tableTotalRow: 0,
      // 表格查询条件
      date: '',
      tableQueryParams: {
        parentRegionId: -1,
        statDate: 0,
        pageNum: 1,
        pageSize: 10
      },
      // 遮罩层
      loading: false,
      // bar和pie数据
      barId: 'bar',
      barData: barData,
      barColor: barColor,
      pieId: 'annular-pie',
      pieData: pieData,
      pieColor: pieColor,
      pieTitle: pieTitle,
      pieLegend: pieLegend,
      pieQueryParams: {
        regionId: -1,
        statDate: 0,
        pageNum: 1,
        pageSize: 10
      },
      // 行业页面
      // 表格数据
      tableData2: [],
      tableTotalRow2: 0,
      date2: '',
      tableQueryParams2: {
        regionKinds: [],
        statDate: 0,
        pageNum: 1,
        pageSize: 10
      },
      industryCascaderOptions: industryCascaderOptions,
      industryCascaderCheckedNodes: [],
      // 默认级联选择器属性2
      defaultCascaderProps: {
        multiple: true
      },
      barId2: 'bar2',
      barData2: barData,
      pieId2: 'annular-pie2',
      pieData2: pieData
    }
  },
  components: {
    Bar,
    AnnularPie,
    AppTreeSide,
    UniDatePicker
  },
  mixins: [
    ssoLoginMixin,
    convertorMixin,
    idNameMixin
  ],
  watch: {
    // 根据名称筛选节点
    treeNodeFilter(val) {
      this.$refs.tree.filter(val.trim())
    },
    treeNodeFilter2(val) {
      this.$refs.tree2.filter(val.trim())
    }
  },
  mounted () {
    this.date = new Date(new Date().getTime() - 3600 * 24 * 1000)
    this.date2 = new Date(new Date().getTime() - 3600 * 24 * 1000)

    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取区域列表
      this.getRegionList2()
    })
  },
  methods: {
    // tabs页面切换
    handleTabClick(tab) {
      if (tab.name === '0') { // 区域

      } else if (tab.name === '1') { // 行业
        if (this.tableTotalRow2 === 0) { // 表格行数视为未初始化
          this.getCameraArchiveStatByIndustryList()
        }
      }
    },
    // 显示或隐藏树侧边栏
    toggleTreeSideBar() {
      this.treeSideBarOpen = !this.treeSideBarOpen
    },
    // 查询区域列表
    getRegionList2() {
      this.loading = true
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        this.loading = false
        this.treeData = []
        this.treeData = loadRegionTree(this.$globalData.regions, this.treeData)
        this.$nextTick(() => {
          if (this.treeData.length) {
            // 默认展开根节点
            this.treeExpandedKeys = [this.treeData[0].key]
            // 设置根节点为当前节点
            this.$refs.tree.setCurrentKey(this.treeData[0].key)
            // 单击当前节点
            this.handleTreeNodeClick(this.$refs.tree.getCurrentNode())
          }
        })
      })
    },
    // 按区域查询摄像机归档统计
    getCameraArchiveStatByRegionList() {
      this.pieQueryParams.statDate = Number(this.date.Format('yyyyMMdd'))
      this.$http(this.$api.cameraArchiveStatByRegionList, this.pieQueryParams).then(
        res => {
          if (res.code === 200) {
            for (let i = 0; i < 4; i++) {
              this.pieData[i + 1][1] = 0
            }
            if (res.data.length) {
              // 全部完善数
              this.pieData2[1][1] = res.data[0].completedCount
              // 未完善数
              this.pieData2[2][1] = res.data[0].notStartedCount
              // 部分完善数
              this.pieData2[3][1] = res.data[0].partiallyCompletedCount
              // 基本完善数
              this.pieData2[4][1] = res.data[0].basicallyCompletedCount
            }
            this.$nextTick(() => {
              this.$refs.annularPie.draw()
            })
          }
        }
      )
    },
    // 按区域查询摄像机归档统计2
    getCameraArchiveStatByRegionList2() {
      this.tableQueryParams.statDate = Number(this.date.Format('yyyyMMdd'))
      this.$http(this.$api.cameraArchiveStatByRegionList, this.tableQueryParams).then(
        res => {
          if (res.code === 200) {
            this.tableData = res.data
            this.tableTotalRow = res.page.totalRow

            // 绘制bar
            let xData = ['各区域数量对比', '接入数', '已完善数', '未完善数']
            this.barData = []
            this.barData.push(xData)
            if (res.data.length) {
              res.data.forEach(item => {
                let yItem = []
                yItem.push(item.regionName)
                yItem.push(item.totalCount)
                yItem.push(item.completedCount)
                yItem.push(item.totalCount - item.completedCount)
                this.barData.push(yItem)
              })
            } else {
              let yItem = ['', 0, 0, 0]
              this.barData.push(yItem)
            }
            this.$nextTick(() => {
              this.$refs.bar.draw()
            })
          }
        })
    },
    // 过滤树节点
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 单击树节点
    handleTreeNodeClick(obj) {
      if (this.tableQueryParams.parentRegionId !== obj.id) {
        this.tableQueryParams.parentRegionId = obj.id
        this.tableQueryParams.pageNum = 1
        this.getCameraArchiveStatByRegionList2()
      }
      if (this.pieQueryParams.regionId !== obj.id) {
        this.pieQueryParams.regionId = obj.id
        this.pieQueryParams.pageNum = 1
        this.getCameraArchiveStatByRegionList()
      }
    },
    // 查询按钮操作
    handleFormQuery() {
      this.tableQueryParams.page = 1
      this.getCameraArchiveStatByRegionList()
      this.getCameraArchiveStatByRegionList2()
    },
    // 重置按钮操作
    resetQueryForm() {
      this.tableQueryParams.regionId = 0
      this.tableQueryParams.statDate = 0
      this.date = new Date()
      this.tableQueryParams.pageNum = 1

      this.pieQueryParams.parentRegionId = 0
      this.tableQueryParams.statDate = 0
      this.date = new Date()
      this.tableQueryParams.pageNum = 1
      this.$refs['queryForm'].resetFields()
      this.handleFormQuery()
    },
    // 分页
    handleCurrentPageChange(val) {
      this.tableQueryParams.pageNum = val
      this.getCameraArchiveStatByRegionList2()
    },
    // 页面条数改变
    handlePageSizeChange(val) {
      this.tableQueryParams.pageSize = val
      this.getCameraArchiveStatByRegionList2()
    },
    // 行业
    // 按行业查询摄像机归档统计
    getCameraArchiveStatByIndustryList() {
      this.tableQueryParams2.statDate = Number(this.date2.Format('yyyyMMdd'))
      // cascader选择节点数组是二维数组，每一项都包含了从根到叶子节点的值，这里只取叶子节点的值
      this.tableQueryParams2.regionKinds = []
      this.industryCascaderCheckedNodes.forEach(item => {
        if (item.length) {
          this.tableQueryParams2.regionKinds.push(item[item.length - 1])
        }
      })
      this.$http(this.$api.cameraArchiveStatByIndustryList, this.tableQueryParams2).then(
        res => {
          if (res.code === 200) {
            this.tableData2 = res.data
            this.tableTotalRow2 = res.page.totalRow

            // 绘制pie
            for (let i = 0; i < 4; i++) {
              this.pieData2[i + 1][1] = 0
            }
            if (res.data.length) {
              // 数据累加
              res.data.forEach(item => {
                // 全部完善数
                this.pieData2[1][1] += item.completedCount
                // 未完善数
                this.pieData2[2][1] += item.notStartedCount
                // 部分完善数
                this.pieData2[3][1] += item.partiallyCompletedCount
                // 基本完善数
                this.pieData2[4][1] += item.basicallyCompletedCount
              })
            }
            this.$nextTick(() => {
              this.$refs.annularPie2.draw()
            })

            // 绘制bar
            let xData = ['各行业数量对比', '接入数', '已完善数', '未完善数']
            this.barData2 = []
            this.barData2.push(xData)
            if (res.data.length) {
              res.data.forEach(item => {
                let yItem = []
                yItem.push(this.getNameById(item.regionKind, this.$type.industries))
                yItem.push(item.totalCount)
                yItem.push(item.completedCount)
                yItem.push(item.totalCount - item.completedCount)
                this.barData2.push(yItem)
              })
            } else {
              let yItem = ['', 0, 0, 0, 0]
              this.barData2.push(yItem)
            }
            this.$nextTick(() => {
              this.$refs.bar2.draw()
            })
          }
        }
      )
    },
    // 查询按钮操作2
    handleFormQuery2() {
      this.tableQueryParams2.page = 1
      this.getCameraArchiveStatByIndustryList()
    },
    // 重置按钮操作2
    resetQueryForm2() {
      this.tableQueryParams2.regionKinds = []
      this.tableQueryParams2.statDate = 0
      this.date = new Date()
      this.tableQueryParams2.pageNum = 1
      this.$refs['queryForm2'].resetFields()
      this.handleFormQuery2()
    },
    // 分页2
    handleCurrentPageChange2(val) {
      this.tableQueryParams2.pageNum = val
      this.getCameraArchiveStatByIndustryList()
    },
    // 页面条数改变2
    handlePageSizeChange2(val) {
      this.tableQueryParams2.pageSize = val
      this.getCameraArchiveStatByIndustryList()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/statistics/cameraArchiveStatistics/CameraArchiveStatistics.js